export default __webpack_public_path__ + "static/wamo-web-pages-mobile-2c3620abb5fb6ea16b006ecdd1861188.jpg";